import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { isOfficialComponent } from "@next-tsx/parser";
import convertModule from "./convertModule.js";
export function convertRoutes(_x, _x2, _x3, _x4) {
  return _convertRoutes.apply(this, arguments);
}
function _convertRoutes() {
  _convertRoutes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(children, state, currentModule, options) {
    var _children$map;
    var routes;
    return _regeneratorRuntime().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return Promise.all((_children$map = children === null || children === void 0 ? void 0 : children.map(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(child) {
              var _convertingPage;
              var _child$properties, path, component, _ref2, reference, componentName, convertingPage, importSource, mod, importedModule, parts, page;
              return _regeneratorRuntime().wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (isOfficialComponent(child, "Route")) {
                      _context.next = 1;
                      break;
                    }
                    throw new Error("All children of <Routes> must be <Route>.");
                  case 1:
                    _child$properties = child.properties, path = _child$properties.path, component = _child$properties.component;
                    if (!(typeof path !== "string" || !path.startsWith("/"))) {
                      _context.next = 2;
                      break;
                    }
                    throw new Error("The \"path\" property of <Route> must be a string starting with \"/\".");
                  case 2:
                    if (component) {
                      _context.next = 3;
                      break;
                    }
                    throw new Error("The \"component\" property of <Route> is required.");
                  case 3:
                    _ref2 = component, reference = _ref2.reference, componentName = _ref2.name; // let page: ConvertedPart | null | undefined;
                    importSource = reference.type === "local" ? currentModule.filePath : reference.importSource;
                    mod = null;
                    if (state.convertedModules.has(importSource)) {
                      mod = state.convertedModules.get(importSource);
                    } else {
                      importedModule = state.app.modules.get(importSource);
                      if (importedModule) {
                        mod = convertModule(importedModule, state, options);
                      }
                      state.convertedModules.set(importSource, mod);
                    }
                    if (mod) {
                      _context.next = 4;
                      break;
                    }
                    throw new Error("Cannot find the module \"".concat(reference.importSource, "\" imported by the route \"").concat(path, "\"."));
                  case 4:
                    if (reference.type === "local") {
                      parts = [].concat(_toConsumableArray(mod.internals), _toConsumableArray(mod.namedExports.values()));
                      convertingPage = parts.find(function (_ref3) {
                        var raw = _ref3.raw;
                        return raw.type !== "function" && raw.type !== "context" && raw.component.id && raw.component.id.name === reference.name;
                      });
                    } else {
                      convertingPage = reference.name ? mod.namedExports.get(reference.name) : mod.defaultExport;
                    }
                    _context.next = 5;
                    return (_convertingPage = convertingPage) === null || _convertingPage === void 0 ? void 0 : _convertingPage.promise;
                  case 5:
                    page = _context.sent;
                    if (page) {
                      _context.next = 6;
                      break;
                    }
                    throw new Error("Cannot find the component \"".concat(reference.name, "\" used in the route \"").concat(path, "\"."));
                  case 6:
                    if (!(page.type !== "page")) {
                      _context.next = 7;
                      break;
                    }
                    throw new Error("The component \"".concat(reference.name, "\" used in the route \"").concat(path, "\" must be a page component."));
                  case 7:
                    return _context.abrupt("return", {
                      path: "${APP.homepage}".concat(path === "/" ? "" : path),
                      alias: componentName,
                      incrementalSubRoutes: true,
                      bricks: page.bricks,
                      context: page.context
                    });
                  case 8:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x5) {
              return _ref.apply(this, arguments);
            };
          }())) !== null && _children$map !== void 0 ? _children$map : []);
        case 1:
          routes = _context2.sent;
          // The more specific routes should come first
          routes.sort(function (a, b) {
            return b.path.length - a.path.length;
          });
          return _context2.abrupt("return", routes);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _convertRoutes.apply(this, arguments);
}
//# sourceMappingURL=convertRoutes.js.map